import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PalantirIconComponent } from '../icon/icon.component';
import { PalantirTextComponent } from '../text/text.component';

@Component({
  selector: 'palantir-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirTextComponent, PalantirIconComponent],
})
export class PalantirCheckboxComponent {
  @Input() public label?: string;
}
